import { render } from "./areaManage.vue?vue&type=template&id=731abbb0&scoped=true"
import script from "./areaManage.vue?vue&type=script&lang=js"
export * from "./areaManage.vue?vue&type=script&lang=js"

import "./areaManage.vue?vue&type=style&index=0&id=731abbb0&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-731abbb0"]])

export default __exports__